import * as React from "react";
import Box from "@mui/material/Box";
import ListIcon from "@mui/icons-material/List";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import GridViewIcon from "@mui/icons-material/GridView";
import { routePath } from "../constants/routePath";
import { useNavigate } from "react-router";

import instagram from "../assets/img/social/instagram.png";
import facebook from "../assets/img/social/facebook.png";
import linkedIn from "../assets/img/social/linkedin.png";
import Youtube from "../assets/img/social/youtube.png";
import { Stars } from "@mui/icons-material";
import { Stack } from "@mui/material";
export default function Footer() {
  const navigate = useNavigate();
  
  return (
    // <Box
    //   sx={{
    //     flexGrow: 1,
    //     position: "fixed",
    //     bottom: "0px",

    //     background: (theme) => theme.palette.primary.main,
    //     width: "100%",
    //   }}
    // >
    //   <Grid
    //     container
    //     spacing={0}
    //     sx={{ p: "10px 0px", borderRight: "0.2px solid #e5e5e5" }}
    //   >
    //     {/* <Grid
    //       item
    //       xs={12}
    //       sx={{
    //         borderRight: "0.2px solid #e5e5e5",
    //         display: "flex",
    //         alignItems: "center",
    //         // justifyContent: "center",
    //       }}
    //     > */}
    //     <Grid container>
    //       <Grid
    //         item
    //         xs={6}
    //         sx={{
    //           display: "flex",
    //           height: "40px",
    //           // justifyContent: "space-around",
    //           alignItems: "center",
    //         }}
    //         onClick={() => {
    //           navigate(routePath.MOBILEPAGEMENU);
    //         }}
    //       >
    //         {" "}
    //         <ListIcon sx={{ m: "0px 10px", color: "white" }} />
    //         <Typography
    //           sx={{ color: "white", fontWeight: "600", m: "0px" }}
    //           gutterBottom
    //           align="center"
    //         >
    //           Menu
    //         </Typography>
    //       </Grid>
    //       <Grid
    //         item
    //         xs={6}
    //         onClick={() => {
    //           navigate(routePath.DASHBOARD);
    //         }}
    //         sx={{
    //           display: "flex",
    //           height: "40px",
    //           // justifyContent: "space-around",
    //           alignItems: "center",
    //         }}
    //       >
    //         <GridViewIcon sx={{ m: "0px 10px", color: "white" }} />
    //         <Typography
    //           sx={{ color: "white", fontWeight: "600", m: "0px" }}
    //           gutterBottom
    //           align="center"
    //         >
    //           Dashboard
    //         </Typography>
    //       </Grid>
    //     </Grid>
    //     <Box></Box>
    //     <Box></Box>
    //     {/* <Typography sx={{ color: "#505050" }} gutterBottom align="center">
    //         Copyright © 2023 MITR Learning & Media. All rights reserved.
    //       </Typography> */}
    //   </Grid>
    //   {/* </Grid> */}
    // </Box>

    <>
      {/* social media section start */}
      <Box
        sx={{
          background:
            "linear-gradient(93.11deg, #7A79FF 13.11%, #01008B 84.65%)",
          // width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "16px",
          paddingY: { sm: "40px", xs: "20px" },
          textAlign: "center",
        }}
      >
        <Typography
          className=""
          fontSize={"21px"}
          sx={{
            fontFamily: "'Montserrat', sans-serif",
            fontWeight: 600,
            fontSize: { xs: "12px", sm: "13px", md: "15px" },
          }}
          color={"#fff"}
        >
          Follow us on social media
        </Typography>
        <Stack direction="row" spacing={2}>
          <Box
            component="a"
            href="https://www.instagram.com/elegant_prime/"
            target="_blank"
          >
            <Box
              component="img"
              src={instagram}
              alt="instagram"
              sx={{
                width: { sm: "48px", xs: "40px" },
                height: { sm: "40px", xs: "35px" },
                objectFit: "contain",
              }}
            />
          </Box>
          <Box
            component="a"
            href="https://www.facebook.com/people/Elegant-Prime/61560201346658/"
            target="_blank"
          >
            <Box
              component="img"
              src={facebook}
              alt="Facebook"
              sx={{
                width: { sm: "48px", xs: "40px" },
                height: { sm: "40px", xs: "35px" },
                objectFit: "contain",
              }}
            />
          </Box>
          <Box
            component="a"
            href="https://www.linkedin.com/company/elegant-prime/"
            target="_blank"
          >
            <Box
              component="img"
              src={linkedIn}
              alt="linkedIn"
              sx={{
                width: { sm: "48px", xs: "40px" },
                height: { sm: "40px", xs: "35px" },
                objectFit: "contain",
              }}
            />
          </Box>
          <Box
            component="a"
            href="https://www.youtube.com/@Elegantprime"
            target="_blank"
          >
            <Box
              component="img"
              src={Youtube}
              alt="youtube"
              sx={{
                width: { sm: "48px", xs: "40px" },
                height: { sm: "40px", xs: "35px" },
                objectFit: "contain",
              }}
            />
          </Box>
        </Stack>
      </Box>
      {/* social media section end */}
      {/* copyright section start */}
      <Box
        sx={{
          height: "146px",
          backgroundColor: "#212529",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "16px",
          padding: "20px",
          textAlign: "center",
        }}
      >
        <Typography className="kanit" fontSize={"14px"} color={"#ffffff"}>
          © Powered by{" "}
          <Box
            component="a"
            href="https://posiviewapps.com/index.html"
            sx={{
              // textDecoration: "none",
              textDecorationLine: "underline",
              textDecorationThickness: "0.5px",
              color: "#ffffff",
              cursor: "pointer",
            }}
          >
            Posiview Application Technologies Pvt. Ltd.
          </Box>{" "}
          2025. All Rights Reserved.
        </Typography>
        <Stack
          direction="row"
          spacing={2}
          component="ul"
          sx={{ padding: 0, margin: 0, listStyle: "none" }}
        >
          <Box component="li">
            <Typography
              sx={{
                textDecoration: "none",
                color: "#ffffff",
                fontSize: "14px",
                cursor: "pointer",
              }}
              onClick={() => navigate(routePath.PRIVACYPOLICY)}
            >
              Privacy
            </Typography>
          </Box>
          <Box
            component="li"
            sx={{ position: "relative", paddingLeft: "16px" }}
          >
            <Typography
              sx={{
                textDecoration: "none",
                color: "#ffffff",
                fontSize: "14px",
                cursor: "pointer",
                "&::before": {
                  content: '"•"',
                  color: "#ffffff80",
                  position: "absolute",
                  left: 0,
                  top: "50%",
                  transform: "translateY(-50%)",
                  fontSize: "12px",
                },
              }}
              onClick={() => navigate(routePath.TERMSOFSERVICE)}
            >
              Terms and conditions
            </Typography>
          </Box>
        </Stack>
      </Box>
      {/* copyright section end */}
    </>
  );
}














// serach = item name    p  items and servies
// search 1  = catogory
// search2 = gender
// search3 = service at